<template>
  <div ref="view" class="goods-page" :style="`padding-bottom:${FooterHeight}px`">
    <!-- 菜单栏（内嵌App时隐藏） -->

    <app-header :title="title" back-type="back-app" />
    <!-- 头图 -->
    <img :src="goodsDetail.combinationIntroduction" alt="" class="good-img" />
    <!-- 商品列表 -->
    <goods-list></goods-list>
    <!--其它类型 购买btn -->
    <div class="foot">
      <!-- 操作栏 -->
      <div class="footer">
        <p class="price">
          <span class="total-num" v-if="totalNum">已选择{{ totalNum }}件，</span>
          <span>合计：</span>
          <span class="shop-price">¥{{ totalPrice }}</span>
          <!-- <del class="original-price" v-if="totalPrice">¥{{ totalPrice }}</del> -->
        </p>
        <button class="btn" :class="{ 'btn-click-disable': clickDisable }" @click="onClickFn">立即支付</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'mint-ui'
import Body from '@/mixins/body'
import { appUser, throttle, toFixedFloat, formatFloat } from '@/utils'
// import { $gotoPosterPage, $openWebPage } from '@/utils/common/native-api'
// import { getPageUrl } from '@/utils/common/url'
import { toLoginView } from '@/utils/init/env-init'
import goodsList from './components/goods-list'
import { bindUserReferrer } from '@/utils/bindUserReferrer'
import { createPreMultiOrder } from '@/api/modules/goods/physical.js'

// 操作名称
const action = 'buyGoods'

export default {
  name: 'goods-physical',
  components: {
    goodsList
  },
  data() {
    return {
      title: '友邻少年',
      goodsList: [],
      goodsIndex: 0, // 选择购买商品的索引
      shareIcon: '',
      price: '',
      FooterHeight: 60
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('goods/physical', [
      'goodsDetail',
      'goodsArr',
      // 限购规则
      'limitData'
    ]),
    ...mapGetters('args', ['goodsIds', 'shareCode', 'fromIntegral']),
    // 商品是否联合限购
    hasLimit() {
      const { hasLimit } = this.limitData || {}
      return hasLimit
    },
    goodsInfo() {
      return this.goodsDetail[this.goodsIndex] || {}
    },
    // shareCode 转换后的 goodsId
    defaultGoods() {
      const { goodsArr: list } = this
      return list.length ? list[0] : {}
    },
    clickDisable() {
      return this.totalNum === 0
    },
    // 商品类型
    goodsType() {
      const { goodsInfo } = this
      const { goodsType } = goodsInfo
      return goodsType
    },
    // 总价
    totalPrice() {
      return this.goodsArr.reduce((pre, cur) => {
        return cur.checked ? formatFloat(pre + cur.salePrice) : pre
      }, 0)
    },
    // 已选总数
    totalNum() {
      return this.goodsArr.filter(item => item.checked).length
    }
  },
  created() {
    let goodsIds
    if (this.$route.query !== undefined) {
      // 通过路由跳转来的页面,参数在 route 里取
      goodsIds = this.$route.query.goodsId || ''
    } else {
      // 通过链接过来, 参数由 URL 解析出来,并且通过 vuex 传到这个组件 mapGetters
      goodsIds = this.goodsIds || ''
    }
    this.goodsIdArr = goodsIds ? goodsIds.split('-').map(parseInt) : []
    this.getCombinationDetail()
  },
  activated() {
    if (localStorage.getItem('goods=physical') === 'reset') {
      this.getCombinationDetail()
      localStorage.removeItem('goods=physical')
    }
  },
  mounted() {
    console.log('监听屏幕切换')
    window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.renderResize, false)
    this.$nextTick(_ => {
      this.FooterHeight = document.querySelector('.foot').clientHeight
      console.log('FooterHeight', this.FooterHeight)
    })
  },
  beforeDestroy() {
    window.removeEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.renderResize,
      false
    )
  },
  methods: {
    renderResize() {
      const { style, clientWidth, clientHeight } = document.documentElement
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏
        style.fontSize = Math.min(clientWidth, clientHeight) / 7.5 + 'px'
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏
        style.fontSize = Math.max(clientWidth, clientHeight) / 7.5 + 'px'
      }
      console.log('屏幕切换啦clientWidth:', clientWidth, clientHeight)
    },
    // 创建预付订单
    preCreate() {
      const goodsIdList = this.goodsArr.filter(item => item.checked).map(item => item.goodsId)
      const userId = appUser.userId
      // 切换预创建订单服务
      const preCreate = () => {
        const data = { goodsIdList, userId }
        return createPreMultiOrder(data)
      }
      const preOrder = preCreate()
      preOrder.catch(({ code, message, data }) => {
        console.log(this.goodsInfo, code, data)

        if (code === 30024 || code === 30008) {
          Toast({
            message: `部分商品售罄或下架，请重新选择商品`,
            position: 'middle'
          })
          this.getCombinationDetail()
          return
        } else if (code !== 0) {
          Toast({ message: '账户异常，请联系班主任。错误code=' + code, position: 'middle' })
        }
      })
      return preOrder
    },
    getCombinationDetail() {
      const data = {
        shareCode: this.shareCode || ''
      }
      this.$store
        .dispatch('goods/physical/getCombinationDetail', data)
        // 检查支付操作（登录成功之后）继续
        .then(res => {
          console.log(res, 'rrrrr')
          // this.enterAfterLogin();
          // this.title = this.defaultGoods.channelSecond
        })
    },
    // 设置分享数据
    setShareData() {
      const { shareMainTitle: title, shareSecondTitle: desc, shareImg: imgUrl } = this.defaultGoods
      if (title) {
        const link = location.href
        return { title, desc, link, imgUrl }
      }
    },
    onClickFn() {
      if (this.clickDisable) {
        Toast('请选择商品')
        return
      }

      this.onClickPay()
    },
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    zero(num) {
      return (num <= 9 ? `0${num}` : num).toString()
    },
    onClickPay: throttle(
      function () {
        localStorage.setItem('isClickRegister', 'true')
        if (!this.hasUser()) {
          return
        }
        // 跳转订单支付
        this.preCreate().then(data => {
          this.orderView()
        })
      },
      1000,
      { leading: true }
    ),
    orderView() {
      this.$router.push({
        path: `/confirm-order/goods-physical`,
        query: {
          paytype: 'goods-physical',
          goodsIdList: this.goodsArr
            .filter(item => item.checked)
            .map(item => item.goodsId)
            .join('-')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.goods-page {
  &::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }

  .content {
    img {
      width: 100%;
      height: auto;
    }
  }
  .good-img {
    width: 100%;
    height: 3rem;
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    border-top: 1px solid #eeeeee;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;

    // 活动抵扣
    .activity_box {
      position: absolute;
      top: -0.75rem;
      left: 0;
      width: 100%;
      height: 0.88rem;
      background-image: url('../../images/goods0929/act_bg.png');
      background-size: 100% 100%;
      font-size: 0.26rem;

      .act_left,
      .act_right {
        padding-bottom: 6px;
      }

      .act_left {
        width: 45%;
        color: #fff;
        justify-content: center;

        img {
          width: 0.36rem;
          height: 0.36rem;
          margin-right: 0.08rem;
        }

        span {
          font-weight: 600;
        }
      }

      .act_right {
        flex: auto;
        text-align: center;
        justify-content: center;
      }

      .act_right,
      .countDown_box {
        font-weight: 600;
        color: #e6432d;
      }
    }

    .footer {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.18rem 0.47rem;
      border-top: none !important;
      background-color: #fff;

      .price {
        display: flex;
        align-items: center;
        flex-direction: row;
        font-size: 0.28rem;
        .total-num {
          color: #999;
        }
        .shop-price-integral {
          font-size: 0.36rem;
          font-weight: bold;
          line-height: 0.54rem;

          span {
            color: #00b25a;
          }
        }

        .shop-price {
          font-size: 0.44rem;
          color: #00b25a;
          font-weight: bold;
          line-height: 0.54rem;
        }

        .original-price {
          color: #999999;
          font-size: 0.26rem;
          line-height: 0.32rem;
          margin-top: 0.1rem;
        }
      }

      .btn {
        padding: 0.24rem 0.4rem;
        background-color: #00b25a;
        border-radius: 0.12rem;
        color: #fff;
      }

      .btn-click-disable {
        // pointer-events: none;
        background-color: #bbbbbb;
        max-width: 3rem;
        font-size: 0.28rem;
        text-align: center;
      }
    }

    .protocol_box {
      font-size: 0.28rem;
      padding: 0 0.47rem 0.3rem 0.47rem;
      justify-content: flex-start;

      .choose_img_box {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 3px;
      }

      .warning_text {
        color: #e6432d;
      }
    }
  }
}
</style>
